import { GetListParams, GetOneParams } from 'react-admin';
import axiosApiInstance from 'src/api/axiosConfig';
import { Resource, SUBJECT_TYPE } from 'src/constants';
import { EducationLevelGroup } from 'src/constants/school/schoolLevel.enum';
import { SubjectGroupList } from './types';
import { EducationLevelGradeRange } from 'src/constants/subjects';
import { SubjectsManager } from 'src/managers/Subjects/SubjectsManager';

const getGroupList = async (params: GetListParams): Promise<SubjectGroupList> => {
    const educationLevelGroup: EducationLevelGroup = params.meta.educationLevelGroup;
    const subjectTypes: SUBJECT_TYPE = params.meta.subjectTypes;

    const response = await axiosApiInstance.get(Resource.SUBJECTS, {
        params: {
            targetGradeRange: EducationLevelGradeRange[educationLevelGroup],
            subjectTypes: subjectTypes ? subjectTypes : SubjectsManager.getSubjectTypesBasic().join(',')
        }
    });

    return response.data;
};

export const getOne = (params: GetOneParams) => {
    return axiosApiInstance.get(`${Resource.SUBJECTS}/${params.id}`).then((response) => {
        const { name, planning, id, version, subject_type, durationMinutes, consultationType } = response.data;
        return {
            data: {
                name,
                planning,
                id,
                version,
                subject_type,
                durationMinutes,
                consultationType
            }
        };
    });
};

export default { getGroupList, getOne };
